var _defs, _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _g5, _g6, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsPhDelivery = function SvgNnIconFlagsPhDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.47 33.81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-PH-delivery_svg__cls-1{fill:#fff}.nn-icon-flags-PH-delivery_svg__cls-3{fill:#0067cc}.nn-icon-flags-PH-delivery_svg__cls-7{fill:#ffd000}"))), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PH-delivery_svg__Lager_22",
    "data-name": "Lager 22"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.12.13h50.22v33.56H.12z",
    className: "nn-icon-flags-PH-delivery_svg__cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.26 12.37H50.2v9.08H.26z",
    className: "nn-icon-flags-PH-delivery_svg__cls-3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.36.26h9.08v33.29h-9.08z",
    className: "nn-icon-flags-PH-delivery_svg__cls-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PH-delivery_svg__Lager_58",
    "data-name": "Lager 58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.25.25h49.97v33.31H.25z",
    style: {
      fill: "#e96826"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M.25.25h49.97v33.31H.25z",
    className: "nn-icon-flags-PH-delivery_svg__cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.22 16.91V.25H.25L29.1 16.91z",
    style: {
      fill: "#003eb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.22 16.91H29.1L.25 33.56h49.97z",
    style: {
      fill: "#e50b25"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.61 13.58a3.33 3.33 0 1 1-3.33 3.33 3.33 3.33 0 0 1 3.33-3.33",
    className: "nn-icon-flags-PH-delivery_svg__cls-7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PH-delivery_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.58 16.91.43.43 6.6-.43-6.6-.43Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PH-delivery_svg__g",
    d: "m29.09 50.83.35.35L35.38 50Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7",
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PH-delivery_svg__g-2",
    d: "m29.09 49.17.35-.35L35.38 50Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7",
    "data-name": "g",
    transform: "translate(-24.77 -33.09)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PH-delivery_svg__i"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PH-delivery_svg__h-2",
    "data-name": "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.64 11.91v.61l5 4.36-4.41-4.97Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PH-delivery_svg__g-3",
    d: "M30.34 46.14v.49l5 3.37Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7",
    "data-name": "g",
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PH-delivery_svg__g-4",
    d: "M31.52 45H32l3.37 5Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7",
    "data-name": "g",
    transform: "translate(-24.77 -33.09)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PH-delivery_svg__j"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PH-delivery_svg__h-3",
    "data-name": "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.61 9.91-.38.4.43 6.6.43-6.6Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PH-delivery_svg__g-5",
    d: "m34.55 43.71-.35.35L35.38 50Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7",
    "data-name": "g",
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PH-delivery_svg__g-6",
    d: "m36.21 43.71.35.35L35.38 50Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7",
    "data-name": "g",
    transform: "translate(-24.77 -33.09)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PH-delivery_svg__i-2",
    "data-name": "i"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PH-delivery_svg__h-4",
    "data-name": "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.58 11.91h-.61l-4.36 5 5-4.36Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PH-delivery_svg__g-7",
    d: "M39.24 45h-.5l-3.36 5Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7",
    "data-name": "g",
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PH-delivery_svg__g-8",
    d: "M40.41 46.14v.49l-5 3.37Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7",
    "data-name": "g",
    transform: "translate(-24.77 -33.09)"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PH-delivery_svg__h-5",
    "data-name": "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.64 16.91-.41-.43-6.6.43 6.6.43Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PH-delivery_svg__g-9",
    d: "m41.67 49.17-.35-.35L35.38 50Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7",
    "data-name": "g",
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PH-delivery_svg__g-10",
    d: "m41.67 50.83-.35.35L35.38 50Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7",
    "data-name": "g",
    transform: "translate(-24.77 -33.09)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PH-delivery_svg__i-3",
    "data-name": "i"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PH-delivery_svg__h-6",
    "data-name": "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.58 21.91v-.61l-5-4.36 4.36 5Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PH-delivery_svg__g-11",
    d: "M40.41 53.86v-.5l-5-3.36Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7",
    "data-name": "g",
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PH-delivery_svg__g-12",
    d: "M39.24 55h-.5l-3.36-5Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7",
    "data-name": "g",
    transform: "translate(-24.77 -33.09)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PH-delivery_svg__j-2",
    "data-name": "j"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PH-delivery_svg__h-7",
    "data-name": "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.61 23.91.43-.43-.43-6.57-.38 6.6Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PH-delivery_svg__g-13",
    d: "m36.21 56.29.35-.35L35.38 50Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7",
    "data-name": "g",
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PH-delivery_svg__g-14",
    d: "m34.55 56.29-.35-.35L35.38 50Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7",
    "data-name": "g",
    transform: "translate(-24.77 -33.09)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PH-delivery_svg__i-4",
    "data-name": "i"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PH-delivery_svg__h-8",
    "data-name": "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.64 21.91h.59l4.36-5-5 4.36Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PH-delivery_svg__g-15",
    d: "M31.52 55H32l3.37-5Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7",
    "data-name": "g",
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PH-delivery_svg__g-16",
    d: "M30.34 53.86v-.5l5-3.36Z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7",
    "data-name": "g",
    transform: "translate(-24.77 -33.09)"
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m24.52 16.47-.03-1.32-.8 1.05-1.27-.38.76 1.09-.76 1.08 1.27-.38.8 1.05.03-1.32 1.25-.43zM4.53 28.32l-1.32.11-.56-1.2-.3 1.29-1.32.17 1.13.68-.25 1.31 1.01-.87 1.16.64-.52-1.22zM3.56 4.58l.52-1.22L2.92 4l-1.01-.87.25 1.3-1.13.69 1.32.17.3 1.29.56-1.2 1.32.11z",
    className: "nn-icon-flags-PH-delivery_svg__cls-7"
  }))));
};
export default SvgNnIconFlagsPhDelivery;